import { useEffect } from 'react';
// useOnOutsideClick aka useOnClickOutside
export function useOnOutsideClick(rootRef, callback) {
    useEffect(function () {
        var roots = (Array.isArray(rootRef)
            ? rootRef.map(function (ref) { return ref.current; })
            : [rootRef.current]).filter(function (node) { return !!node; });
        if (roots.length === 0) {
            return;
        }
        var checkOutsideClick = function (e) {
            var target = e.target;
            if (!roots.some(function (root) {
                var _a;
                return root.contains(target) || ((_a = target
                    .closest('.ignore-react-onclickoutside')) === null || _a === void 0 ? void 0 : _a.contains(target));
            })) {
                callback(e);
            }
        };
        document.addEventListener('mousedown', checkOutsideClick);
        document.addEventListener('touchstart', checkOutsideClick);
        return function () {
            document.removeEventListener('mousedown', checkOutsideClick);
            document.removeEventListener('touchstart', checkOutsideClick);
        };
    }, [callback, rootRef]);
}
//# sourceMappingURL=useOnOutsideClick.js.map